import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Button, ButtonGroup, Grid as MUIGrid } from '@mui/material';
import clientViewSx from './ClientView.styles';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import Profile from './Profile';
import { actions } from './ClientView.redux';
import classnames from 'classnames';
import ClientContactMethods from './ClientContactMethods';
import ClientReports from './ClientReports';
import ClientPatients from './ClientPatients';
import ClientCharts from './ClientCharts';
import ClientAddresses from './ClientAddresses';
import FileManager from 'components/FileManager';
import { useParams } from 'react-router-dom';
import { actions as fileActions } from 'components/FileManager/FileManager.redux';



const columns = [
	{ name: 'client_name', title: 'Name' },
	{ name: 'client_external_id', title: 'External ID' },
	{ name: 'last_visit', title: 'Last Visit' },
	{ name: 'address_city', title: 'City' },
	{ name: 'address_state', title: 'State' },
];


const ClientView = () => {

	const tab           = useSelector(state => state.clientView.tab),
		  dispatch      = useDispatch(),
		  resetAll      = () => dispatch(actions.resetAll()),
		  { client_id } = useParams();

	const theme = useTheme();
	const sx = clientViewSx(theme);

	const openFileManager = () => dispatch(fileActions.setState({ open: true, page: 'client' }));



	const handleTabChange = useCallback((e) => {
		if(tab === e.currentTarget.name) {
			return false;
		}

		dispatch(actions.setState({ tab: e.currentTarget.name }));
	}, [ dispatch, tab ]);


	useEffect(() => {
		return () => {
			resetAll();
		};
	}, [ dispatch ]);


	return (
		<MUIGrid container spacing={4}>
			<MUIGrid size={{ xs: 12, sm: 12, lg: 4, xl: 3 }}>
				<Profile />
			</MUIGrid>

			<MUIGrid size={{ xs: 12, sm: 12, lg: 8, xl: 9 }}>
				<Box sx={sx.buttonGroupContainer}>
					<ButtonGroup fullWidth variant="contained">
						<Button
							size="large"
							name="patients"
							onClick={handleTabChange}
							sx={tab === 'patients'
								? sx.patientsActive
								: sx.patientsInactive}
						>
							Patients
						</Button>

						<Button
							size="large"
							name="charts"
							onClick={handleTabChange}
							sx={tab === 'charts'
								? sx.visitsActive
								: sx.visitsInactive}
						>
							Charts
						</Button>

						<Button
							size="large"
							name="reports"
							onClick={handleTabChange}
							sx={tab === 'reports'
								? sx.reportsActive
								: sx.reportsInactive}
						>
							Reports
						</Button>


						<Button
							size="large"
							name="contactMethods"
							onClick={handleTabChange}
							sx={tab === 'contactMethods'
								? sx.contactMethodActive
								: sx.contactMethodInactive}
						>
							Contact Methods
						</Button>

						<Button
							size="large"
							name="addresses"
							onClick={handleTabChange}
							sx={tab === 'addresses'
								? sx.addressesActive
								: sx.addressesInactive}
						>
							Addresses
						</Button>

						<Button
							size="large"
							name="files"
							onClick={openFileManager}
						>
							Files
						</Button>

					</ButtonGroup>
				</Box>

				{tab === 'contactMethods' && <ClientContactMethods />}
				{tab === 'addresses' && <ClientAddresses />}
				{tab === 'patients' && <ClientPatients />}
				{tab === 'reports' && <ClientReports />}
				{tab === 'charts' && <ClientCharts />}

				<FileManager
					selectActions={[]}
					client_id={client_id}
					defaultPage="client"
				/>


			</MUIGrid>
		</MUIGrid>
	);

};



export default ClientView;
